import {createActions} from 'reduxsauce';

export const {Types: ProductTypes, Creators: ProductActionCreators} = createActions ({
    productStart: ['id'],
    productSuccess: ['product'],
    productFailure: ['error'],
    careStart: ['productId'],
    careSuccess: ['data'],
    careFailure: ['error'],
    compositionStart: ['productId'],
    compositionSuccess: ['data'],
    compositionFailure: ['error'],
    productCompositeStart: ['id', 'headers'],
    productCompositeSuccess: ['data'],
    productCompositeFailure: ['error'],
    getBarcodeProductStart: ['data'],
});
